module.exports = __webpack_public_path__ + "static/media/ticketSignatureCheck.7b5fcf20.svg";